module.exports = __webpack_public_path__ + "static/media/ru.793fe37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ru.svg
// module id = 219
// module chunks = 0